import { render } from "./EmployedByEmployer.vue?vue&type=template&id=b8f56148"
import script from "./EmployedByEmployer.vue?vue&type=script&lang=js"
export * from "./EmployedByEmployer.vue?vue&type=script&lang=js"
script.render = render

export default script